<template>
    <div class="select-city">
        <span
            :class="{'right-input': true, isActive: showCity}"
            tabindex="0"
            ref="input"
            readonly="readonly"
            autocomplete="off"
            @blur="onShowCity('blur')"
            @click="onShowCity('focus')"
        >
            {{location.cityName}}
            <i :class="{'c-icon': true, isActive: showCity}">&#xe614;</i>
        </span>
        <div
            :style="{display: showCity ? '' : 'none'}"
            class="select-city-wrapper"
            @mouseenter="handleMouseEnter('enter')"
            @mouseleave="handleMouseEnter('out')"
        >
            <city-selector :visible="showCity" @selectcity="onSelectCity" />
        </div>
    </div>
</template>

<script>
/**
 * @file
 * @author
 */
import citySelector from '@/components/city-selector';
import {mapGetters, mapMutations} from 'vuex';
import {get} from 'lodash';

export default {
    data() {
        return {
            showCity: false,
            canClose: true
        };
    },
    props: {
        carInfo: {
            type: Object,
            default: () => {}
        },
        selectItem: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        'city-selector': citySelector
    },
    methods: {
        ...mapMutations({
            setLocation: 'SET_LOC'
        }),
        onShowCity(act) {
            if (!this.canClose) {
                return;
            }
            if (act === 'focus' && !this.showCity) {
                this.showCity = true;
                this.$emit(
                    'sendlog',
                    'ask_price_city_down_click',
                    {
                        seriesId: this.carInfo.series_id,
                        modelId: get(this.selectItem, 'modelId')
                    }
                );
                this.$emit('sendubclog', 'selectCity', {
                    type: 'show'
                });
            }
            else {
                this.showCity = false;
            }
        },
        handleMouseEnter(act) {
            this.canClose = act !== 'enter';
            if (act !== 'enter') {
                this.$refs.input.focus();
            }
        },
        onSelectCity(city) {
            this.setLocation({
                cityName: city.name,
                cityCode: city.code,
                province: city.province,
                index: city.index
            });
            this.canClose = true;
            this.$nextTick(() => {
                this.onShowCity('blur');
                this.$emit('selectcity');
            });
            this.$emit(
                'sendlog',
                'ask_price_choose_city',
                {
                    seriesId: this.carInfo.series_id,
                    modelId: get(this.selectItem, 'modelId')
                }
            );
            this.$emit('sendubclog', 'selectCity');
        }
    },
    computed: {
        ...mapGetters({
            location: 'location'
        })
    }
};
</script>

<style lang="less" scoped>
@themeColor: #00CECF;

.select-city {
    position: relative;
    width: 234px;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    .right-input {
        padding: 0 12px;
        display: block;
        border: 1px solid #EEEEEE;
        border-radius: 3px;
        outline: none;
        transition: border .15s linear;
        cursor: pointer;
        &.isActive {
            border-color: @themeColor;
        }
    }
    i {
        float: right;
        margin-left: 12px;
        transition: all .15s linear;
        /* 关闭双击反色 */
        user-select: none;
        &.isActive {
            transform: rotate(-180deg);
        }
    }
    &-wrapper {
        position: absolute;
        top: 46px;
        z-index: 9;
    }
}
</style>